import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import {createLogger} from 'redux-logger';

import rootReducer from './reducers';

export default function configureStore() {
    const middlewares = [thunk];

    if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
        const logger = createLogger({collapsed: true});
        middlewares.push(logger);
    }

    return createStore(rootReducer, applyMiddleware(...middlewares));
}
